@if (isLoading()) {
  <div class="flex justify-center items-center h-32">
    <mat-spinner diameter="40" />
  </div>
} @else {
  <div class="flex flex-col gap-4">
    @if (accommodations().length === 0) {
      <p class="text-center text-gray-500 py-8">{{ 'waters.accommodations.no-accommodations' | translate }}</p>
    } @else {
      <mat-table [dataSource]="accommodations()">
        <!-- Number column -->
        <ng-container matColumnDef="number">
          <mat-header-cell *matHeaderCellDef>{{ 'waters.accommodations.column.number' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.number !== null ? ('waters.accommodations.column.number-format' | translate: { number: row.number }) : '—' }}
          </mat-cell>
        </ng-container>

        <!-- Name column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>{{ 'waters.accommodations.column.name' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.name ?? '—' }}</mat-cell>
        </ng-container>

        <!-- Persons column -->
        <ng-container matColumnDef="persons">
          <mat-header-cell *matHeaderCellDef>{{ 'waters.accommodations.column.persons' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.persons ?? '—' }}</mat-cell>
        </ng-container>

        <!-- Spots column -->
        <ng-container matColumnDef="spots">
          <mat-header-cell *matHeaderCellDef>{{ 'waters.accommodations.column.anglers-count' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.spots ?? '—' }}</mat-cell>
        </ng-container>

        <!-- Active column -->
        <ng-container matColumnDef="isActive">
          <mat-header-cell *matHeaderCellDef>{{ 'waters.accommodations.column.active' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row"><app-bool [value]="row.isActive" /></mat-cell>
        </ng-container>

        <!-- Fishing spot column -->
        <ng-container matColumnDef="isFishingSpot">
          <mat-header-cell *matHeaderCellDef>{{ 'waters.accommodations.column.fishing-spot' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row"><app-bool [value]="row.isFishingSpot" /></mat-cell>
        </ng-container>

        <!-- Actions column -->
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'waters.accommodations.column.actions' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <button
              mat-icon-button
              [matTooltip]="'waters.form.edit-title' | translate"
              (click)="editAccommodation(row.id); $event.stopPropagation()">
              <mat-icon>edit</mat-icon>
            </button>
            <button
              mat-icon-button
              color="warn"
              [matTooltip]="'waters.form.delete' | translate"
              [disabled]="deletingId() === row.id"
              (click)="deleteAccommodation(row.id); $event.stopPropagation()">
              @if (deletingId() === row.id) {
                <mat-spinner diameter="18" />
              } @else {
                <mat-icon>delete</mat-icon>
              }
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns" />
        <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="editAccommodation(row.id)" class="cursor-pointer hover:bg-gray-50" />
      </mat-table>
    }
  </div>
}
